import EmptyState from 'src/presentation/components/molecules/EmptyState';
import Translations from 'src/core/utils/Translations';
import type { MessagesEmptyStateProps } from 'src/presentation/components/molecules/MessagesEmptyStateTypes';

/**
 * Web sibling of the inbox's empty state.
 *
 * The inbox is keyed on a device's push token: the API takes the token in its path and answers from
 * the rows queued for it. A browser has no such token -- NotificationService's web sibling returns
 * none -- so the store never even asks and the list is always empty. Telling a visitor "you have no
 * messages" would be untrue: the messages exist and are addressed to the events they belong to,
 * this is simply not a place they can be read. So say that, and point at the app.
 *
 * The search variant is deliberately not repeated here. With nothing to search through, "no results
 * for that term" would send someone looking for a search problem that is not there.
 */
export default function MessagesEmptyState(_props: MessagesEmptyStateProps) {
	return (
		<EmptyState
			icon="phone-portrait-outline"
			message={Translations.messageWebOnlyMessage}
			title={Translations.messageWebOnlyTitle}
		/>
	);
}
